import { render, staticRenderFns } from "./mlista.vue?vue&type=template&id=0122ef02&scoped=true&"
import script from "./mlista.vue?vue&type=script&lang=js&"
export * from "./mlista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122ef02",
  null
  
)

export default component.exports